import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";

const useTitle = (title: string) => {
  const { practice } = useSelector((state: RootState) => ({
    practice: state?.practice,
  }));

  useEffect(() => {
    document.title = title
      ? `${title} • ${practice?.name ? `${practice.name}` : "MWI Pet"}`
      : "MWI Pet";
  }, [title, practice]);
};

export default useTitle;
